module.exports = __webpack_public_path__ + "static/media/133-world.ad318dbb.svg";